/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const colors = {
    //Old color tokens
    transparent: 'transparent',
    current: 'currentColor',
    white: 'oklch(100% 0 0)',

    null: 'transparent',

    black: {
        10: 'oklch(94.68% 0.0046 78.3)',
        20: 'oklch(92.51% 0.0029 84.56)',
        30: 'oklch(86.84% 0.002 17.2)',
        40: 'oklch(83.05% 0.001 17.2)',
        50: 'oklch(76.21% 0.004 301.4)',
        60: 'oklch(66.55% 0.01 286.1)',
        70: 'oklch(54.39% 0.014 280.9)',
        80: 'oklch(42.79% 0.021 282)',
        90: 'oklch(40.94% 0.0217 281.91)',
        100: 'oklch(0% 0 0)',
    },

    'brand-primary': {
        60: 'oklch(58.85% 0.072 269.9)',
        80: 'oklch(42.96% 0.107 268.4)',
        100: 'oklch(30.36% 0.181 264.1)',
    },

    'brand-secondary': {
        60: 'oklch(54.39% 0.014 280.9)',
        80: 'oklch(42.79% 0.021 282)',
        100: 'oklch(22.61% 0.065 273.7)',
    },

    'brand-tertiary': {
        60: 'oklch(97.69% 0.001 17.2)',
        80: 'oklch(95.29% 0.001 17.2)',
        100: 'oklch(89.87% 0.005 286.3)',
    },

    danger: {
        60: 'oklch(91.79% 0.017 31.1)',
        80: 'oklch(76.49% 0.103 21.2)',
        100: 'oklch(42.86% 0.165 27.9)',
    },

    success: {
        60: 'oklch(91.23% 0.011 141.3)',
        80: 'oklch(82.68% 0.032 157)',
        100: 'oklch(45.61% 0.12 152)',
    },
    warning: {
        80: 'oklch(0.715 0.154 64)',
        100: 'oklch(0.665 0.147 62)',
    },

    borderLight: 'oklch(89.55% 0.003 67.8)',
    borderDark: 'oklch(22.61% 0.065 273.7)',
    'border-inverse': 'oklch(96.44% 0.003 84.6)',

    overlayBackgroundModal: 'rgba(0, 0, 0, 0.75)',
    imageBackground: 'rgba(0,0,0,.05)',
    'date-picker-grey': '#C9C9C9',
    'accessibility-blue-light': '#15D6EA',
    'accessibility-blue-dark': '#1B96FF',
    'promo-background': ' #D9DCDE',

    // New color pallete
    neutral: {
        0: 'oklch(96.5% 0.0029 84.56)',
        25: 'oklch(95.61% 0.0034 67.78)',
        50: 'oklch(94.68% 0.0046 78.3)',
        100: 'oklch(92.51% 0.0029 84.56)',
        200: 'oklch(91.68% 0.0035 67.78)',
        300: 'oklch(89.55% 0.0035 67.78)',
        400: 'oklch(86.84% 0.0022 17.2)',
        500: 'oklch(83.05% 0.0011 17.18)',
        600: 'oklch(76.21% 0.0044 301.4)',
        700: 'oklch(66.55% 0.0102 286.12)',
        800: 'oklch(54.39% 0.0139 280.86)',
        900: 'oklch(40.94% 0.0217 281.91)',
        950: 'oklch(22.61% 0.0654 273.71)',

        alphaDark: {
            0: 'oklch(22.61% 0.0654 273.71 / 0)',
            50: 'oklch(22.61% 0.0654 273.71 / 0.04)',
            100: 'oklch(22.61% 0.0654 273.71 / 0.08)',
            200: 'oklch(22.61% 0.0654 273.71 / 0.12)',
            300: 'oklch(22.61% 0.0654 273.71 / 0.16)',
            400: 'oklch(22.61% 0.0654 273.71 / 0.24)',
            500: 'oklch(22.61% 0.0654 273.71 / 0.4)',
            600: 'oklch(22.61% 0.0654 273.71 / 0.56)',
            700: 'oklch(22.61% 0.0654 273.71 / 0.64)',
            800: 'oklch(22.61% 0.0654 273.71 / 0.72)',
            900: 'oklch(22.61% 0.0654 273.71 / 0.8)',
            950: 'oklch(22.61% 0.0654 273.71 / 0.95)',
        },

        alphaWhite: {
            0: 'oklch(94.68% 0.0046 78.3 / 0)',
            50: 'oklch(94.68% 0.0046 78.3 / 0.04)',
            100: 'oklch(94.68% 0.0046 78.3 / 0.08)',
            200: 'oklch(94.68% 0.0046 78.3 / 0.12)',
            300: 'oklch(94.68% 0.0046 78.3 / 0.16)',
            400: 'oklch(94.68% 0.0046 78.3 / 0.24)',
            500: 'oklch(94.68% 0.0046 78.3 / 0.4)',
            600: 'oklch(94.68% 0.0046 78.3 / 0.56)',
            700: 'oklch(94.68% 0.0046 78.3 / 0.64)',
            800: 'oklch(94.68% 0.0046 78.3 / 0.72)',
            900: 'oklch(94.68% 0.0046 78.3 / 0.8)',
            950: 'oklch(94.68% 0.0046 78.3 / 0.88)',
        },
    },

    brand: {
        0: 'oklch(95.29% 0.0011 17.18)',
        50: 'oklch(92.27% 0.0011 17.18)',
        100: 'oklch(91.03% 0.0027 286.35)',
        200: 'oklch(89.87% 0.0054 286.29)',
        300: 'oklch(88.83% 0.0072 268.54)',
        400: 'oklch(86.38% 0.0115 269.54)',
        500: 'oklch(82.77% 0.02 273.19)',
        600: 'oklch(77.82% 0.0306 273)',
        700: 'oklch(67.3% 0.052 270.93)',
        800: 'oklch(58.85% 0.0715 269.91)',
        900: 'oklch(42.96% 0.1071 268.39)',
        950: 'oklch(30.36% 0.1806 264.09)',

        alpha: {
            0: 'oklch(30.36% 0.1806 264.09 / 0)',
            50: 'oklch(30.36% 0.1806 264.09 / 0.04)',
            100: 'oklch(30.36% 0.1806 264.09 / 0.08)',
            200: 'oklch(30.36% 0.1806 264.09 / 0.12)',
            300: 'oklch(30.36% 0.1806 264.09 / 0.16)',
            400: 'oklch(30.36% 0.1806 264.09 / 0.24)',
            500: 'oklch(30.36% 0.1806 264.09 / 0.4)',
            600: 'oklch(30.36% 0.1806 264.09 / 0.56)',
            700: 'oklch(30.36% 0.1806 264.09 / 0.64)',
            800: 'oklch(30.36% 0.1806 264.09 / 0.72)',
            900: 'oklch(30.36% 0.1806 264.09 / 0.8)',
            950: 'oklch(30.36% 0.1806 264.09 / 0.95)',
        },
    },

    green: {
        0: 'oklch(94.87% 0.0062 137.77)',
        50: 'oklch(91.23% 0.0114 141.26)',
        100: 'oklch(88.66% 0.017 151.08)',
        200: 'oklch(86.78% 0.022 154.07)',
        300: 'oklch(82.68% 0.0324 157.05)',
        400: 'oklch(74.62% 0.0551 160.14)',
        500: 'oklch(66.65% 0.0767 160.02)',
        600: 'oklch(58.74% 0.0977 158.03)',
        700: 'oklch(54.77% 0.1052 157.34)',
        800: 'oklch(51.13% 0.1134 155.33)',
        900: 'oklch(45.61% 0.119964 152.012)',
        950: 'oklch(29.46% 0.0794 150.93)',

        alpha: {
            0: 'oklch(45.61% 0.119964 152.012 / 0)',
            50: 'oklch(45.61% 0.119964 152.012 / 0.04)',
            100: 'oklch(45.61% 0.119964 152.012 / 0.08)',
            200: 'oklch(45.61% 0.119964 152.012 / 0.12)',
            300: 'oklch(45.61% 0.119964 152.012 / 0.16)',
            400: 'oklch(45.61% 0.119964 152.012 / 0.24)',
            500: 'oklch(45.61% 0.119964 152.012 / 0.4)',
            600: 'oklch(45.61% 0.119964 152.012 / 0.56)',
            700: 'oklch(45.61% 0.119964 152.012 / 0.64)',
            800: 'oklch(45.61% 0.119964 152.012 / 0.72)',
            900: 'oklch(45.61% 0.119964 152.012 / 0.8)',
            950: 'oklch(45.61% 0.119964 152.012 / 0.95)',
        },
    },

    red: {
        0: 'oklch(94.21% 0.0123 29.87)',
        50: 'oklch(91.79% 0.017 31.09)',
        100: 'oklch(89.15% 0.0305 25.3)',
        200: 'oklch(84.53% 0.0544 22.54)',
        300: 'oklch(76.49% 0.1028 21.2)',
        400: 'oklch(67.94% 0.1618 22.78)',
        500: 'oklch(61.06% 0.2068 26.09)',
        600: 'oklch(56.66% 0.2256 28.68)',
        700: 'oklch(48.87% 0.1931 28.42)',
        800: 'oklch(42.86% 0.1646 27.86)',
        900: 'oklch(38.53% 0.1431 27.58)',
        950: 'oklch(25.17% 0.0908 26.77)',

        alpha: {
            0: 'oklch(38.53% 0.1431 27.58 / 0)',
            50: 'oklch(38.53% 0.1431 27.58 / 0.04)',
            100: 'oklch(38.53% 0.1431 27.58 / 0.08)',
            200: 'oklch(38.53% 0.1431 27.58 / 0.12)',
            300: 'oklch(38.53% 0.1431 27.58 / 0.16)',
            400: 'oklch(38.53% 0.1431 27.58 / 0.24)',
            500: 'oklch(38.53% 0.1431 27.58 / 0.4)',
            600: 'oklch(38.53% 0.1431 27.58 / 0.56)',
            700: 'oklch(38.53% 0.1431 27.58 / 0.64)',
            800: 'oklch(38.53% 0.1431 27.58 / 0.72)',
            900: 'oklch(38.53% 0.1431 27.58 / 0.8)',
            950: 'oklch(38.53% 0.1431 27.58 / 0.95)',
        },
    },

    blue: {
        0: 'oklch(94.47% 0.0052 247.88)',
        50: 'oklch(92.23% 0.0077 241.67)',
        100: 'oklch(90.53% 0.0146 244.73)',
        200: 'oklch(88.05% 0.0287 246.5)',
        300: 'oklch(86.32% 0.0376 247.01)',
        400: 'oklch(81.68% 0.0557 252.7)',
        500: 'oklch(75.73% 0.0804 255.15)',
        600: 'oklch(66.99% 0.1169 256.28)',
        700: 'oklch(55.37% 0.2107 261.98)',
        800: 'oklch(51.19% 0.2263 262.27)',
        900: 'oklch(47.11% 0.2045 262.17)',
        950: 'oklch(28.55% 0.0921 262.26)',

        alpha: {
            0: 'oklch(47.11% 0.2045 262.17 / 0)',
            50: 'oklch(47.11% 0.2045 262.17 / 0.04)',
            100: 'oklch(47.11% 0.2045 262.17 / 0.08)',
            200: 'oklch(47.11% 0.2045 262.17 / 0.12)',
            300: 'oklch(47.11% 0.2045 262.17 / 0.16)',
            400: 'oklch(47.11% 0.2045 262.17 / 0.24)',
            500: 'oklch(47.11% 0.2045 262.17 / 0.4)',
            600: 'oklch(47.11% 0.2045 262.17 / 0.56)',
            700: 'oklch(47.11% 0.2045 262.17 / 0.64)',
            800: 'oklch(47.11% 0.2045 262.17 / 0.72)',
            900: 'oklch(47.11% 0.2045 262.17 / 0.8)',
            950: 'oklch(47.11% 0.2045 262.17 / 0.95)',
        },
    },

    bronze: {
        0: 'oklch(94.16% 0.0052 67.76)',
        50: 'oklch(92.28% 0.0075 80.72)',
        100: 'oklch(89.73% 0.0115 71.89)',
        200: 'oklch(86.94% 0.0128 75.36)',
        300: 'oklch(84.13% 0.014 78.25)',
        400: 'oklch(80.67% 0.0154 80.7)',
        500: 'oklch(76.04% 0.0192 78.21)',
        600: 'oklch(69.05% 0.0202 75.25)',
        700: 'oklch(60.97% 0.0264 73.43)',
        800: 'oklch(55.58% 0.0301 74.5)',
        900: 'oklch(42.91% 0.0226 75.02)',
        950: 'oklch(32.79% 0.0139 76.38)',

        alpha: {
            0: 'oklch(42.91% 0.0226 75.02 / 0)',
            50: 'oklch(42.91% 0.0226 75.02 / 0.04)',
            100: 'oklch(42.91% 0.0226 75.02 / 0.08)',
            200: 'oklch(42.91% 0.0226 75.02 / 0.12)',
            300: 'oklch(42.91% 0.0226 75.02 / 0.16)',
            400: 'oklch(42.91% 0.0226 75.02 / 0.24)',
            500: 'oklch(42.91% 0.0226 75.02 / 0.4)',
            600: 'oklch(42.91% 0.0226 75.02 / 0.56)',
            700: 'oklch(42.91% 0.0226 75.02 / 0.64)',
            800: 'oklch(42.91% 0.0226 75.02 / 0.72)',
            900: 'oklch(42.91% 0.0226 75.02 / 0.8)',
            950: 'oklch(42.91% 0.0226 75.02 / 0.95)',
        },
    },

    slate: {
        0: 'oklch(93.04% 0.0027 106.45)',
        50: 'oklch(91.81% 0.0011 197.14)',
        100: 'oklch(89.27% 0.0043 236.5)',
        200: 'oklch(85.47% 0.0106 247.95)',
        300: 'oklch(82.19% 0.0178 248.05)',
        400: 'oklch(74.43% 0.0286 249.93)',
        500: 'oklch(66.8% 0.0387 249.69)',
        600: 'oklch(52.59% 0.0449 249.83)',
        700: 'oklch(42.17% 0.0433 253.76)',
        800: 'oklch(35.4% 0.0457 252.68)',
        900: 'oklch(26.5% 0.0435 254.61)',
        950: 'oklch(26.5% 0.0435 254.61)',

        alpha: {
            0: 'oklch(35.4% 0.0457 252.68 / 0)',
            50: 'oklch(35.4% 0.0457 252.68 / 0.04)',
            100: 'oklch(35.4% 0.0457 252.68 / 0.08)',
            200: 'oklch(35.4% 0.0457 252.68 / 0.12)',
            300: 'oklch(35.4% 0.0457 252.68 / 0.16)',
            400: 'oklch(35.4% 0.0457 252.68 / 0.24)',
            500: 'oklch(35.4% 0.0457 252.68 / 0.4)',
            600: 'oklch(35.4% 0.0457 252.68 / 0.56)',
            700: 'oklch(35.4% 0.0457 252.68 / 0.64)',
            800: 'oklch(35.4% 0.0457 252.68 / 0.72)',
            900: 'oklch(35.4% 0.0457 252.68 / 0.8)',
            950: 'oklch(35.4% 0.0457 252.68 / 0.95)',
        },
    },
}

export default colors
